<span class="badge !py-2 !px-3 !text-lg !text-white !text-xs" [class]="bgColor()">
  <i [class]="icon()" class="mr-2"></i>
  {{ "TAGS." + tag().name | translate }}
  @if(removable()){
  <i class="ml-2 fa-regular fa-circle-xmark cursor-pointer" (click)="removeTag()"></i>
  }
</span>
